{
  "runFrequencies": [
    "Daily",
    "Weekly/Mondays",
    "Weekly/Tuesday",
    "Weekly/Wednesday",
    "Weekly/Thursday",
    "Weekly/Friday",
    "Monthly/EOM"
  ],
  "reportTypes": [
    {
      "shortName": "marketRiskSpot",
      "longName": "Market Risk - Spot",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "currencyPair",
          "longName": "Currency Pair",
          "type": "dropdown",
          "placeHolder": "Currency Pair",
          "options": [],
          "dynamicOptionsToUse": "currencyPairs",
          "validators": ["required"]
        },
        {
          "shortName": "width",
          "longName": "Width",
          "type": "percent",
          "placeHolder": "Value",
          "validators": ["required", "biggerThanZeroPercent"]
        },
        {
          "shortName": "numpts",
          "longName": "Number Of Points",
          "type": "number",
          "placeHolder": "Value",
          "validators": ["required", "min3"]
        }
      ]
    },
    {
      "shortName": "marketRiskVol",
      "longName": "Market Risk - Vol",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Value",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "currencyPair",
          "longName": "Currency Pair",
          "type": "dropdown",
          "placeHolder": "Currency Pair",
          "options": [],
          "dynamicOptionsToUse": "currencyPairs",
          "validators": ["required"]
        },
        {
          "shortName": "lowestVolShift",
          "longName": "Lowest Vol Shift",
          "type": "percent",
          "placeHolder": "Value",
          "validators": ["required", "biggerThanOrEqualZero"]
        },
        {
          "shortName": "highestVolShift",
          "longName": "Highest Vol Shift",
          "type": "percent",
          "placeHolder": "Value",
          "validators": ["required", "biggerThanOrEqualZero"]
        },
        {
          "shortName": "numpts",
          "longName": "Number of Points",
          "type": "number",
          "placeHolder": "Value",
          "validators": ["required", "min3"]
        }
      ]
    },
    {
      "shortName": "marketRiskTheta",
      "longName": "Market Risk - Theta",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        }
      ]
    },
    {
      "shortName": "cvaReport",
      "longName": "CVA Report",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "counterParty",
          "longName": "Counter Party",
          "type": "dropdown",
          "placeHolder": "Counter Party",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        }
      ]
    },
    {
      "shortName": "2WeekPfe",
      "longName": "2-week PFE",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "counterParty",
          "longName": "Counter Party",
          "type": "dropdown",
          "placeHolder": "Counter Party",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        }
      ]
    },
    { "shortName": "valueAll", "longName": "Value All", "parameters": [] },
    {
      "shortName": "clientValuation",
      "longName": "Client Valuation",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        }
      ]
    },
    {
      "shortName": "liquidityRisk",
      "longName": "Liquidity Risk",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        }
      ]
    },
    {
      "shortName": "pnlExplain",
      "longName": "pnl Explain",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "fromDate",
          "longName": "From Date",
          "type": "date",
          "placeHolder": "dd mmm yyyy",
          "validators": ["required", "fromDateValidator"]
        },
        {
          "shortName": "lag",
          "longName": "Lag",
          "type": "dropdown",
          "placeHolder": "Counter Party",
          "options": ["T-1b", "T-1w"],
          "validators": ["required"]
        },
        {
          "shortName": "fromTime",
          "longName": "Time",
          "type": "dropdown",
          "placeHolder": "Time",
          "options": ["New York 3pm", "London 4pm"],
          "validators": ["required"]
        }
      ]
    },
    {
      "shortName": "eventsReport",
      "longName": "Events Report",
      "parameters": [
        {
            "shortName": "entity",
            "longName": "Entity",
            "type": "dropdown",
            "placeHolder": "Entity",
            "options": [],
            "dynamicOptionsToUse": "entities",
            "validators": ["required"]
          },
          {
          "shortName": "includeCashProducts",
          "longName": "Cash Products",
          "type": "checkbox",
          "validators":[]
        },
        {
          "shortName": "horizon",
          "longName": "Horizon",
          "type": "text",
          "placeHolder": "Horizon",
          "validators": ["numberAnd-d/b/w"]
        }
      ]
    },
    {
      "shortName": "historicalVar",
      "longName": "Historical VaR",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "counterParty",
          "longName": "Counter Party",
          "type": "dropdown",
          "placeHolder": "Counter Party",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        }
      ]
    },
    {
      "shortName": "expectedFlows",
      "longName": "Expected Flows",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "counterParty",
          "longName": "Counter Party",
          "type": "dropdown",
          "placeHolder": "Counter Party",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": []
        }
      ]
    },
    {
      "shortName": "barriersReport",
      "longName": "Barriers Report",
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "validators": ["required"],
          "dynamicOptionsToUse": "entities"
        }
      ]
    },
    {
      "shortName": "riskMatrix",
      "longName": "Risk Matrix",
      "outputParameters": [
        {
          "shortName": "price",
          "longName": "Price",
          "type": "text",
          "placeHolder": "Price",
          "options": [],
          "validators": []
        },
        {
          "shortName": "fxDelta",
          "longName": "FX Delta",
          "type": "dropdown",
          "placeHolder": "FX Delta",
          "dynamicOptionsToUse": "currencyPairs",
          "options": [],
          "validators": ["required"]
        },
        {
          "shortName": "fxVega",
          "longName": "FX Vega",
          "type": "dropdown",
          "placeHolder": "FX Vega",
          "dynamicOptionsToUse": "currencyPairs",
          "options": [],
          "validators": ["required"]
        },
        {
          "shortName": "DV01",
          "longName": "DV01",
          "type": "dropdown",
          "placeHolder": "DV01",
          "options": ["3m USD LIBOR"],
          "validators": ["required"]
        }
      ],
      "parameters": [
        {
          "shortName": "entity",
          "longName": "Entity",
          "type": "dropdown",
          "placeHolder": "Entity",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "counterParties",
          "longName": "Counter Parties",
          "type": "multi-select",
          "placeHolder": "No counter parties selected",
          "placeHolderSingle": "Counter party selected",
          "placeHolderMulti": "Counter parties selected",
          "options": [],
          "dynamicOptionsToUse": "entities",
          "validators": ["required"]
        },
        {
          "shortName": "x-axis",
          "longName": "X-Axis",
          "type": "parameters",
          "placeHolder": "",
          "parameters": [
            {
              "shortName": "underlyingType",
              "longName": "Underlying Type",
              "type": "dropdown",
              "placeHolder": "Underlying Type",
              "options": ["FX Vol", "FX Spot", "IR Index"],
              "validators": ["required"]
            },
            {
              "shortName": "underlying",
              "longName": "Underlying",
              "type": "dropdown",
              "placeHolder": "Underlying",
              "options": [],
              "validators": ["required"]
            },
            {
              "shortName": "numpts",
              "longName": "Number Of Points",
              "type": "number",
              "placeHolder": "Number Of Points",
              "options": [],
              "validators": ["required", "min3", "integer", "max11"]
            },
            {
              "shortName": "maxLowerShift",
              "longName": "Max Lower Shift",
              "type": "percent",
              "placeHolder": "Max Lower Shift",
              "validators": ["required", "lessThanZeroPercent"]
            },
            {
              "shortName": "maxUpperShift",
              "longName": "Max Upper Shift",
              "type": "percent",
              "placeHolder": "Max Upper Shift",
              "validators": ["required", "biggerThanZeroPercent"]
            }
          ],
          "validators": []
        },
        {
          "shortName": "y-axis",
          "longName": "Y-Axis",
          "type": "parameters",
          "placeHolder": "",
          "parameters": [
            {
              "shortName": "underlyingType",
              "longName": "Underlying Type",
              "type": "dropdown",
              "placeHolder": "Underlying Type",
              "options": ["FX Vol", "FX Spot", "IR Index"],
              "validators": ["required"]
            },
            {
              "shortName": "underlying",
              "longName": "Underlying",
              "type": "dropdown",
              "placeHolder": "Underlying",
              "options": [],
              "validators": ["required"]
            },
            {
              "shortName": "numpts",
              "longName": "Number Of Points",
              "type": "number",
              "placeHolder": "Number Of Points",
              "options": [],
              "validators": ["required", "min3", "integer", "max11"]
            },
            {
              "shortName": "maxLowerShift",
              "longName": "Max Lower Shift",
              "type": "percent",
              "placeHolder": "Max Lower Shift",
              "validators": ["required", "lessThanZeroPercent"]
            },
            {
              "shortName": "maxUpperShift",
              "longName": "Max Upper Shift",
              "type": "percent",
              "placeHolder": "Max Upper Shift",
              "validators": ["required", "biggerThanZeroPercent"]
            }
          ],
          "validators": []
        }
      ]
    }
  ],
  "marketDataTime": ["Live", "London 4pm", "London 3.30pm", "New York 3pm"],
  "timezones": [
    "America/Mexico_City",
    "America/New_York",
    "America/Santiago",
    "America/Sao_Paulo",
    "Asia/Bangkok",
    "Asia/Calcutta",
    "Asia/Dubai",
    "Asia/Hong_Kong",
    "Asia/Istanbul",
    "Asia/Jakarta",
    "Asia/Kuala_Lumpur",
    "Asia/Seoul",
    "Asia/Shanghai",
    "Asia/Singapore",
    "Asia/Tokyo",
    "Australia/Canberra",
    "Europe/Berlin",
    "Europe/Istanbul",
    "Europe/Jersey",
    "Europe/London",
    "Europe/Luxembourg",
    "Europe/Paris",
    "Europe/Zurich",
    "UTC"
  ],
  "times": [
    "00:00",
    "00:15",
    "00:30",
    "00:45",
    "01:00",
    "01:15",
    "01:30",
    "01:45",
    "02:00",
    "02:15",
    "02:30",
    "02:45",
    "03:00",
    "03:15",
    "03:30",
    "03:45",
    "04:00",
    "04:15",
    "04:30",
    "04:45",
    "05:00",
    "05:15",
    "05:30",
    "05:45",
    "06:00",
    "06:15",
    "06:30",
    "06:45",
    "07:00",
    "07:15",
    "07:30",
    "07:45",
    "08:00",
    "08:15",
    "08:30",
    "08:45",
    "09:00",
    "09:15",
    "09:30",
    "09:45",
    "10:00",
    "10:15",
    "10:30",
    "10:45",
    "11:00",
    "11:15",
    "11:30",
    "11:45",

    "12:00",
    "12:15",
    "12:30",
    "12:45",
    "13:00",
    "13:15",
    "13:30",
    "13:45",
    "14:00",
    "14:15",
    "14:30",
    "14:45",
    "15:00",
    "15:15",
    "15:30",
    "15:45",
    "16:00",
    "16:15",
    "16:30",
    "16:45",
    "17:00",
    "17:15",
    "17:30",
    "17:45",
    "18:00",
    "18:15",
    "18:30",
    "18:45",
    "19:00",
    "19:15",
    "19:30",
    "19:45",
    "20:00",
    "20:15",
    "20:30",
    "20:45",
    "21:00",
    "21:15",
    "21:30",
    "21:45",
    "22:00",
    "22:15",
    "22:30",
    "22:45",
    "23:00",
    "23:15",
    "23:30",
    "23:45"
  ],
  "underlyingTypeIsIrIndex": ["3m USD LIBOR"]
}
